import createApiClient from './apiClient';
import { cachedRequest } from '../utils/apiDataCache';

function userServiceBase() {
  return (process.env.REACT_APP_ATHENIAN_USER_SERVICE_URL || '').replace(/\/api\/users\/?$/, '');
}

const locationApi = createApiClient(`${userServiceBase()}/api/locations`);

export const getAllStates = () =>
  cachedRequest('locations:states:all', () => locationApi.get('/states'), 86400000);

export const getAllCities = (stateCode) =>
  cachedRequest(
    `locations:cities:all:${stateCode || 'all'}`,
    () => locationApi.get('/cities', { params: stateCode ? { state_code: stateCode } : {} }),
    86400000,
  );
